/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/no-explicit-any
export const getBundlerVersion = (): any => window.BUNDLER_VERSION;
